export type HikeBackground =
  | 'tatry'
  | 'malaga'
  | 'madera'
  | 'tatry2Old'
  | 'tatry2'
  | 'dymin'
  | 'rumunia'
  | 'portugalia'
  | 'goryStolowe';

export type HikeTrip = {
  id: string;
  sortDate: string;
  section: 'upcoming' | 'archived';
  titleKey: string;
  destinationKey: string;
  dateKey: string;
  extraDateKeys?: string[];
  seatsKey?: string;
  background: HikeBackground;
  route: string;
  buttonKey: string;
};

export const HIKE_TRIPS: HikeTrip[] = [
  {
    id: 'goryStolowe2026',
    sortDate: '2026-10-01',
    section: 'upcoming',
    titleKey: 'hiking.goryStolowe2026',
    destinationKey: 'hiking.destination-goryStolowe2026',
    dateKey: 'hiking.date-goryStolowe2026',
    seatsKey: 'hiking.seats-goryStolowe2026',
    background: 'goryStolowe',
    route: '/projects/hiking/2026/gory-stolowe',
    buttonKey: 'button.sign-up-now',
  },
  {
    id: 'dymin2026',
    sortDate: '2026-07-24',
    section: 'archived',
    titleKey: 'hiking.dymin2026',
    destinationKey: 'hiking.destination-dymin2026',
    dateKey: 'hiking.date-dymin2026',
    background: 'dymin',
    route: '/projects/hiking/2026/dymin',
    buttonKey: 'button.read-how-it-was',
  },
  {
    id: 'rumunia2026',
    sortDate: '2026-06-26',
    section: 'archived',
    titleKey: 'hiking.rumunia2026',
    destinationKey: 'hiking.destination-rumunia2026',
    dateKey: 'hiking.date-rumunia2026',
    background: 'rumunia',
    route: '/projects/hiking/2026/rumunia',
    buttonKey: 'button.read-how-it-was',
  },
  {
    id: 'portugalia2026',
    sortDate: '2026-03-01',
    section: 'archived',
    titleKey: 'hiking.portugalia2026',
    destinationKey: 'hiking.destination-portugalia2026',
    dateKey: 'hiking.date-portugalia2026',
    background: 'portugalia',
    route: '/projects/hiking/2026/portugalia',
    buttonKey: 'button.read-how-it-was',
  },
  {
    id: 'slowacja2026',
    sortDate: '2026-05-28',
    section: 'archived',
    titleKey: 'hiking.slowacja2026',
    destinationKey: 'hiking.destination-slowacja2026',
    dateKey: 'hiking.date-slowacja2026',
    background: 'tatry2',
    route: '/projects/hiking/2026/slowacja',
    buttonKey: 'button.read-how-it-was',
  },
  {
    id: 'tatry2',
    sortDate: '2025-06-12',
    section: 'archived',
    titleKey: 'hiking.tatry2',
    destinationKey: 'hiking.destination-tatry2',
    dateKey: 'hiking.date-tatry2',
    background: 'tatry2Old',
    route: '/projects/hiking/tatry2',
    buttonKey: 'button.read-how-it-was',
  },
  {
    id: 'madera',
    sortDate: '2025-03-09',
    section: 'archived',
    titleKey: 'hiking.madera',
    destinationKey: 'hiking.destination-madera',
    dateKey: 'hiking.date-madera',
    extraDateKeys: ['hiking.date-madera2'],
    background: 'madera',
    route: '/projects/hiking/madera',
    buttonKey: 'button.read-how-it-was',
  },
  {
    id: 'malaga',
    sortDate: '2024-09-25',
    section: 'archived',
    titleKey: 'hiking.malaga',
    destinationKey: 'hiking.destination-malaga',
    dateKey: 'hiking.date-malaga',
    background: 'malaga',
    route: '/projects/hiking/malaga',
    buttonKey: 'button.read-how-it-was',
  },
  {
    id: 'tatry',
    sortDate: '2024-06-06',
    section: 'archived',
    titleKey: 'hiking.tatry',
    destinationKey: 'hiking.destination-tatry',
    dateKey: 'hiking.date-tatry',
    background: 'tatry',
    route: '/projects/hiking/tatry',
    buttonKey: 'button.read-how-it-was',
  },
];
